import { CartesianGrid, XAxis, Bar, LabelList, BarChart } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { ChartConfig, ChartContainer } from "../ui/chart";
import { AmountOnDate } from "@/api/types/main/schemas";
import { format, compareAsc } from "date-fns";
import { ru } from "date-fns/locale";
import { useMemo } from "react";

const chartConfig: ChartConfig = {
  orders: {
    label: "Заказы",
    color: "hsl(var(--chart-3))",
  },
} satisfies ChartConfig;

export const CardOrdersWeeksChart = ({ orders = [] }: { orders: AmountOnDate[] }) => {
  const chartData = useMemo(
    () =>
      [...orders]
        .sort((a, b) => compareAsc(a.date, b.date))
        .map((item) => ({
          date: format(item.date, "d MMM", { locale: ru }),
          value: item.value,
        })),
    [orders]
  );

  const dateRange = useMemo(() => {
    if (!chartData.length) return "Нет данных";
    return `${chartData[0].date} - ${chartData[chartData.length - 1].date}`;
  }, [chartData]);

  return (
    <Card className="flex flex-col h-full w-full">
      <CardHeader className="flex-none">
        <CardTitle>Заказы за неделю</CardTitle>
        <CardDescription>{dateRange}</CardDescription>
      </CardHeader>
      <CardContent className="h-full w-full flex items-center justify-center">
        {chartData.length > 0 ? (
          <ChartContainer config={chartConfig} className="w-full h-full aspect-[6/1]">
            <BarChart
              accessibilityLayer
              data={chartData}
              margin={{
                top: 25,
              }}
            >
              <CartesianGrid />
              <XAxis dataKey="date" tickLine={false} tickMargin={10} axisLine={false} />

              <Bar dataKey="value" fill="var(--color-orders)" radius={8}>
                <LabelList position="top" offset={12} className="fill-foreground" fontSize={12} />
              </Bar>
            </BarChart>
          </ChartContainer>
        ) : (
          <div className="h-full w-full flex items-center justify-center">
            Нет данных за последнюю неделю
          </div>
        )}
      </CardContent>
    </Card>
  );
};
